import { Injectable } from '@angular/core';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { PaymentTracker } from '../models/paymentTracker';

@Injectable({
    providedIn: 'root'
})

export class PaymentTrackerService {
    controller = 'PaymentTracker';

    constructor(private base: BaseService) { } 

    registerPaymentTracker(obj: PaymentTracker) {
        return this.base.save(this.controller + '/RegisterPaymentTracker', obj);
    }

    getPaymentTrackerById(teacherId: number): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetPaymentTrackerById/' + teacherId)
    }

    confirmPayment(obj: PaymentTracker) {
        return this.base.save(this.controller + '/ConfirmPayment', obj);
    }
}